import BaseModel from '../base/BaseModel.model';
import { ParesEvaluadoresTypes } from '@/enums/ParesEvaluadoresTypes';
import Respuesta from './respuesta.model';
import Porposal from '../porposal/porposal.model';
import User from '../security/user.model';
import { EvaluationState } from '@/enums/EvaluationState';
import TipoEvaluacion from './tipoEvaluacion.model';

export default class Evaluacion extends BaseModel {

    public userId: number | null = null;
    public porposalId:number | null = null;
    public evaluationTypeId:ParesEvaluadoresTypes | null = null;
    public evaluationType:TipoEvaluacion | null = null;
    public respuestas: Array<Respuesta> = [];
    public fueCompletada: boolean = false;
    public isApproved: boolean = false;
    public evaluationState: EvaluationState;
    public porposal: Porposal | null = null;
    public user: User | null = null;
    public motivoEvaluacion: string | null = null;
    
    constructor(){
        super();
        this.init();
    }

    init(){}
}